import { render, staticRenderFns } from "./DirectPlacementCommissionsTable.vue?vue&type=template&id=cf7899c0"
import script from "./DirectPlacementCommissionsTable.vue?vue&type=script&lang=js"
export * from "./DirectPlacementCommissionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports